<template>
    <v-container>
        <v-row>
            <v-col><h1>Campaigns</h1></v-col>
        </v-row>

        <v-row>
            <v-col cols="12" sm="6" lg="4" v-for="(campaign, index) of campaigns" :key="index">

                <v-card>
                    <v-card-title>{{ campaign.title }}</v-card-title>

                    <v-card-text>
                        <!-- TODO Scenario count, Party count, Character count -->
                        <div>Prosperity: {{ campaign.prosperity }}</div>
                        <div>Starting Level: {{ campaign.characterStartingLevel }}</div>
                        <div>Starting Gold: {{ campaign.characterStartingGold }}</div>
                    </v-card-text>

                    <v-divider/>

                    <v-card-actions>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn icon
                                       color="primary"
                                       @click="$router.push({name: 'campaign', params: {campaignId: campaign.id}})"
                                       v-on="on"
                                >
                                    <v-icon>mdi-eye</v-icon>
                                </v-btn>
                            </template>
                            <span>View Campaign</span>
                        </v-tooltip>
                    </v-card-actions>
                </v-card>

            </v-col>
        </v-row>

        <v-row>
            <v-col>
                <v-card>
                    <v-card-title>Create New Campaign</v-card-title>

                    <v-card-text>
                        <v-text-field v-model="form.title"
                                      @keypress.enter="storeCampaign"
                                      label="Title of new campaign..."/>
                    </v-card-text>

                    <v-divider/>

                    <v-card-actions>
                        <v-btn text color="primary" @click="storeCampaign" :loading="loading">Create</v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
  import CampaignService from "../services/CampaignService";

  export default {
    data: () => ({
      campaigns: [{
        id: null,
        title: null,
        prosperity: null,
        characterStartingLevel: null,
        characterStartingExperience: null,
        characterStartingGold: null,
        users: [{
          id: null,
          name: null
        }]
      }],
      loading: false,
      form: {
        title: null
      }
    }),

    created() {
      if (this.$store.state.isUserLoggedIn === false) {
        this.$router.push({name: 'auth'});
      }

      this.indexCampaigns();
    },

    methods: {
      indexCampaigns() {
        CampaignService.index()
          .then(response => {
            this.campaigns = response.data.data;
          });
      },

      setCampaign(campaign) {
        this.$store.dispatch("setCampaign", campaign);
        this.$router.push({name: "home"});
      },

      storeCampaign() {
        this.loading = true;

        CampaignService.store(this.form)
          .then(() => {
            this.indexCampaigns();
            this.form = {title: null};
            this.loading = false;
          })
          .catch(err => {
            console.log(err);
            this.loading = false;
          });
      }
    }
  };
</script>
